// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"2":"b16619cf","38":"e54b3b84","388":"b16619cf","449":"b16619cf","548":"b16619cf","559":"fc06398d","560":"c0da3c7f"}[chunkId] + ".css";
};